import { types, actions } from './requests'
export const DELETEKIT_TYPES = {
    ...types('DELETEKIT'),
}
export const DELETEKIT_ACTIONS = {
    ...actions('DELETEKIT'),
}